import { BuiltInFieldId } from 'src/app/models/built-in-field-id.enum';
import { SelectFilterComponent } from '../../select-filter/select-filter.component';
import { AdvancedFieldValue } from './advanced-field-value';
import { FieldDisplayType } from './field-display-type';
import { FilterComparerGuids } from './filter-comparer-guids';
import { FilterFieldGuids } from './filter-field-guids';
import { FieldValue } from './field-value';

export class SavedFilterField {
    fieldId: string;
    displayType: FieldDisplayType;
    comparer: string;
    value: any[];
    group?: string;
    not?: boolean;
}

export class SavedFilterFieldFactory {
    static createFromSimple(ff: FieldValue): SavedFilterField {
        let comparer = FilterComparerGuids.Contains;

        switch (ff.field.displayType) {
            case FieldDisplayType.Text:
            case FieldDisplayType.CustomCodingText:
                if (ff.field.fieldId === BuiltInFieldId.DocId || ff.field.fieldId === BuiltInFieldId.TextGroupId || ff.field.fieldId === FilterFieldGuids.EmailThreadId) comparer = FilterComparerGuids.Is;
                if (!ff.value[0]) comparer = FilterComparerGuids.IsBlank;
                break;
            case FieldDisplayType.Boolean:
            case FieldDisplayType.CustomCodingCheckbox:
            case FieldDisplayType.CustomCodingSharedCheckbox:
                comparer = null;
                break;
            case FieldDisplayType.DateRange:
            case FieldDisplayType.ControlNumber:
                if (ff.value[0] && !ff.value[1]) {
                    comparer = FilterComparerGuids.After;
                } else if (!ff.value[0] && ff.value[1]) {
                    comparer = FilterComparerGuids.Before;
                } else if (ff.value[0] && ff.value[1]) {
                    comparer = FilterComparerGuids.Between;
                } else {
                    comparer = FilterComparerGuids.Is;
                }
                break;
            case FieldDisplayType.StaticDropdown:
            case FieldDisplayType.MultiSelect:
            case FieldDisplayType.Bates:
            case FieldDisplayType.SearchReport:
                comparer = FilterComparerGuids.Is;
                break;
        }

        this.replaceBlankInSourceAndType(ff);
        return {
            fieldId: ff.field.fieldId,
            displayType: ff.field.displayType,
            comparer: comparer,
            value: ff.value
        };
    }

    static createFromAdvanced(advancedField: AdvancedFieldValue): SavedFilterField {
        this.replaceBlankInSourceAndType(advancedField);

        return {
            fieldId: advancedField.field.fieldId,
            displayType: advancedField.field.displayType,
            comparer: advancedField.comparer,
            value: advancedField.value,
            group: advancedField.group,
            not: advancedField.groupNot
        };
    }

    private static replaceBlankInSourceAndType(sf: FieldValue) {
        if (sf.field.fieldId === BuiltInFieldId.DocSource || sf.field.fieldId === BuiltInFieldId.DocType) {
            for (let index = 0; index < sf.value.length; index++) {
                if (sf.value[index] === SelectFilterComponent.blank) {
                    sf.value[index] = '';
                    break;
                }
            }
        }
    }
}
